export const FEATURES = {
    ADD_CHILD: 'addChild',
    EDIT_CHILD_PROFILE: 'EDIT_CHILD_PROFILE',
    EDIT_ANALYST_PROFILE: 'EDIT_ANALYST_PROFILE',
    PACKEGE: 'package',
};